export default __webpack_public_path__ + "images/14d64a7f2f492f23c08e1a1fd096ddb8.png";